var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-area"},[_vm._t("menu",function(){return [_c('app-menu')]}),_vm._t("sidebar",function(){return [_c('app-sidebar')]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }